import "./Security.css";
import { motion } from "framer-motion";
import {
  FiCamera,
  FiMic,
  FiMoon,
  FiThermometer,
} from "react-icons/fi";
import productImage from "../../assets/images/telsiz.png";

const features = [
  {
    icon: <FiMic />,
    title: "Ses Takibi",
    text: "Ağlama ve ortam seslerini takip ederek dikkat gerektiren durumları ayırt etmeye yardımcı olur.",
  },
  {
    icon: <FiCamera />,
    title: "Görüntü Takibi",
    text: "Bebeğinizin odasındaki görüntü akışını sade bir şekilde izleyebilmenizi hedefler.",
  },
  {
    icon: <FiThermometer />,
    title: "Oda Koşulları",
    text: "Sıcaklık ve nem değişimlerini izler; konfor aralığı dışına çıkıldığında sizi bilgilendirir.",
  },
  {
    icon: <FiMoon />,
    title: "Uyku ve Pozisyon",
    text: "Uyku süreci ve pozisyon değişiklikleri hakkında anlaşılır, anlık bildirimler sunar.",
  },
];

function Security() {
  return (
    <section className="security" id="security">
      <div className="container">
        <motion.div
          className="security-heading"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <span>GİZLİLİK ODAKLI MİMARİ</span>

          <h2 className="section-title">
            Bebeğinizin durumunu izler,
            <br />
            sizi anında bilgilendirir.
          </h2>

          <p className="section-subtitle security-subtitle">
            Bybebek, ebeveynlerin en çok merak ettiği bilgileri basit ve anlaşılır
            hale getirir. Önemli bir değişiklik olduğunda mobil uygulama üzerinden
            anlık bildirim alırsınız.
          </p>
        </motion.div>

        <div className="security-wrapper">
          <motion.div
            className="security-product-display"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >
            <div className="security-product-glow"></div>
            <img src={productImage} alt="Bybebek akıllı bebek takip cihazı" />
          </motion.div>

          <motion.div
            className="security-info"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >
            <div className="security-list">
              {features.map((feature) => (
                <article className="security-item" key={feature.title}>
                  <div className="security-icon">{feature.icon}</div>
                  <div>
                    <h3>{feature.title}</h3>
                    <p>{feature.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Security;
